module.exports = __webpack_public_path__ + "static/media/0002.b6ac1e00.jpg";